import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pu-support-circle-image',
  templateUrl: './support-circle-image.component.html',
  styleUrls: ['./support-circle-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class SupportCircleImageComponent {}
